/** Billing API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {BillingNs, CommonNs} from '@shared/types'

const product = createApi('product')
const payment = createApi('payment')
const company = createApi('company')

export const BillingApi = {
  // — product —
  getSubscriptionInfo: (data: BillingNs.GetSubscriptionInfoRequest) =>
    product.post<BillingNs.GetSubscriptionInfoRequest, BillingNs.SubscriptionInfo>('get-subscription-detail', data),

  // — payment —
  getCustomerCards: () =>
    payment.post<void, BillingNs.CardInfo[]>('retrieve-cards'),
  getBillingAddresses: (custId: string) =>
    payment.post<void, BillingNs.BillingAddress[]>(`retrieve-customer/${custId}`),
  deleteBillingAddress: (custId: string) =>
    payment.post<void, CommonNs.AnyResponse>(`delete-customer/${custId}`),
  deletePaymentMethod: (custId: string) =>
    payment.post<void, CommonNs.AnyResponse>(`delete-card/${custId}`),
  getSubscriptionInfos: () =>
    payment.post<void, BillingNs.SubscriptionInfo[]>('retrieve-subscriptions'),

  // — company (billing/payment kaydı) —
  updateBillingAddress: (data: BillingNs.BillingAddress) =>
    company.post<BillingNs.BillingAddress, CommonNs.AnyResponse | Error>('create-customer', data),
  updatePaymentMethod: (data: BillingNs.PaymentMethod) =>
    company.post<BillingNs.PaymentMethod, CommonNs.AnyResponse | Error>('create-customer', data),
}
